/**
 * Unit-level chapter labels — there is no unit-title field in the `Lesson`
 * data model (only per-lesson `titleHi`/`titleEn`), so this hardcodes the
 * chapter heading per unit number, mirroring the `VARGA_LABELS` pattern in
 * `Varnamala.tsx`. Kept in sync manually with the unit map documented atop
 * `@repo/hindi-shared`'s `lessons.ts`. Shared by the Lessons chapter list
 * and the session summary's unit-completion line.
 */
export const UNIT_LABELS: Record<number, { hi: string; en: string }> = {
  1: { hi: "स्वर", en: "Vowels" },
  2: { hi: "व्यंजन", en: "Consonants" },
  3: { hi: "मात्राएँ", en: "Matras" },
  4: { hi: "अंक", en: "Numerals" },
  5: { hi: "संयुक्ताक्षर", en: "Conjuncts" },
  6: { hi: "नुक़्ता", en: "Nukta letters" },
  7: { hi: "प्रवाह", en: "Fluency" },
};
